import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itfacility-revoke-grid',
  templateUrl: './itfacility-revoke-grid.component.html',
  styleUrls: ['./itfacility-revoke-grid.component.scss']
})
export class ITfacilityRevokeGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
